import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../../layouts/DefaultLayout'
import InitPasswordForm, {
  InitPasswordFormProps,
} from '../../../components/forms/PasswordForm/InitPasswordForm'
import * as SC from '../styled'

export type InitPasswordTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  initPasswordForm: InitPasswordFormProps
}

const InitPasswordTemplate: FC<InitPasswordTemplateProps> = (props) => {
  const { layout, initPasswordForm } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <InitPasswordForm {...initPasswordForm} />
      </SC.Content>
    </DefaultLayout>
  )
}

export default InitPasswordTemplate
